<template>
  <div>
    <div id='respConsole'>
      <div v-cloak v-for='(resp, index) in respLst' transition='fade' :key='resp.transId'
            :class="[resp.data.Result == 'FAIL' ? 'h-mml-resp-bgc fail': 'h-mml-resp-bgc']">
        <div class='h-mml-respItembox'>
          <label>{{$t('MML.beginTime')}}</label>
          <div>{{resp.startTime | formatDateFilter}}</div>
        </div>
        <div class='h-mml-respItembox'>
          <label>{{$t('MML.endTime')}}</label>
          <div>{{resp.endTime | formatDateFilter}}</div>
        </div>
        <div class='h-mml-respItembox h-mml-wholeLine'>
          <label>{{$t('MML.mmlCommand')}}</label>
          <div class='h-mml-resp-showCmd'>{{resp.cmd}}</div>
        </div>
        <div class='h-mml-respItem'>
          <label class='h-mml-xybox'>{{$t('MML.mmlResponse')}}</label>
          <div>
            <component :is='selectRespComponent(resp)' :resp='resp'></component>
          </div>
        </div>
        <span :class="[resp.data.Result === 'FAIL' ? 'h-mml-resp-seqError icon hero-icon hero-icon-detailed': 'h-mml-resp-seqSuccess icon hero-icon hero-icon-confirm']"></span>
        <span class='h-mml-resp-remove' @click='remove(resp,index)'><span class='icon hero-icon hero-icon-remove-small h-mml-icon-size'></span></span>
      </div>
    </div>
    <ejs-contextmenu id='mmlRespRightMenu' ref='mmlRespRightMenu' target='#respConsole' :items='menuItems' :select='deleteAllResp'></ejs-contextmenu>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ShowData from '@/components/mmlconfig/respItem/ShowData';
import ShowErrorMsg from '@/components/mmlconfig/respItem/ShowErrorMsg';
import ShowMsgContent from '@/components/mmlconfig/respItem/ShowMsgContent';
import ShowProgress from '@/components/mmlconfig/respItem/ShowProgress';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import mmlSocket from '@/plugins/stompSock';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'CommandResp',
  components: {
    ShowData,
    ShowErrorMsg,
    ShowMsgContent,
    ShowProgress
  },
  mixins: [packageParams],
  data() {
    return {
      respLst: [],
      // 批量修改 保存最近两次的执行结果，若连续两次执行失败，则结束本次批量操作
      recent2ExecuteResult: ['OK', 'OK'],
      payload: [
        { topic: '/user/#/MMLServer', clientId: this.getUserId(), callback: this.mmlWebsocketLisener }
      ],
      menuItems: [
        {text: this.$t('MML.deleteAll')}
      ]
    };
  },
  computed: {
    ...mapGetters(['isMassModExecing', 'cmdMode']),
  },
  mounted() {
    console.log('-------------------exec mounted');
    // 接收MML websocket 响应事件 暂时屏蔽
    // this.lisenWebSocketEvent();
    mmlSocket.init(this.payload);
  },
  filters: {
    formatDateFilter(timeStamp) {
      const now = new Date(timeStamp);
      const year = now.getFullYear();  //取得4位数的年份
      const month = (Array(2).join('0') + (now.getMonth()+1)).slice(-2);  //取得日期中的月份，其中0表示1月，11表示12月
      const date = (Array(2).join('0') + now.getDate()).slice(-2);      //返回日期月份中的天数（1到31）
      const hour = (Array(2).join('0') + now.getHours()).slice(-2);     //返回日期中的小时数（0到23）
      const minute = (Array(2).join('0') + now.getMinutes()).slice(-2); //返回日期中的分钟数（0到59）
      const second = (Array(2).join('0') + now.getSeconds()).slice(-2); //返回日期中的秒数（0到59）
      return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    }
  },
  methods: {
    ...mapMutations(['changeMmlOperButtonDisabled']),
    deleteAllResp(args) {
      if(args.item.text === this.$t('MML.deleteAll')) {
        this.respLst = [];
      }
    },
    remove(resp, index) {
      this.respLst.splice(index, 1);
    },
    selectRespComponent(resp) {
      if (resp.data.Result === 'MID') {
        if (resp.data.Data[0].MessageContent) {
          return 'ShowMsgContent';
        }
        if (resp.data.Data[0].Progress) {
          return 'ShowProgress';
        }
      }
      if (resp.data.Result === 'FAIL' || resp.data.InterfaceType === 'ALT') {
        return 'ShowErrorMsg';
      }
      if (resp.data.InterfaceType === 'QRY') {
        return 'ShowData';
      }
      if (resp.data.InterfaceType === 'MNT') {
        if (resp.data.Data.length>0 && resp.data.Data[0].MessageContent) {
          return 'ShowMsgContent';
        }
        if (resp.data.Data.length>0 && resp.data.Data[0].Progress){
          return 'ShowProgress';
        }
        //修改原因：act命令显示操作结果。TODO：后续按以下方式修改，Data不为空，showData
        if (resp.data.Operation === 'RST' || resp.data.Operation === 'ACT'){
          return 'ShowErrorMsg';
        }
        return 'ShowData';
      }
      return 'ShowErrorMsg';
    },
    mmlWebsocketLisener(wsMessage) {
      // console.log("mmlWebsocketLisener",wsMessage);
      const message = JSON.parse(wsMessage.body);
      console.log("mmlWebsocketLisener",message);
      let oldMsg = this.respLst.find(resp => resp.transId === message.transId);
      if (!oldMsg) {
        oldMsg = message;
        if(message.errorCode =="0"){
          if(message.mo.moId =='107' || message.mo.moId =='57'){
              oldMsg.datas = [];  //  2022-1206   //oldMsg.datas = [message.data] 改为[] 增加定义要不无法push
              oldMsg.datas.push(oldMsg.data);
            }else{
              oldMsg.datas = [];  //  2022-1206   //oldMsg.datas = [message.data] 改为[] 增加定义要不无法push
           }
        }else{
          oldMsg.datas = [];
        }
        this.respLst.unshift(oldMsg);
      } else {
        oldMsg.data.Result = message.data.Result;

        if (oldMsg.data.Data[0] && oldMsg.data.Data[0].MessageContent) {
          if (message.data.Result === 'FAIL') {
            message.data.Data = [{ MessageContent: message.errorMsg }];
            oldMsg.data.Result = 'FAIL';
            oldMsg.errorMsg = message.errorMsg;
          }
          oldMsg.datas.push(message.data);
          if(!message.data.Data[0].MessageContent){  //20240221 外场ERT ALD 不显示问题修改
            oldMsg.datas = [];
            oldMsg.data.Data = message.data.Data;
          }
        } else if (oldMsg.data.Data[0] && oldMsg.data.Data[0].Progress) {
          if (message.data.Result === 'FAIL') {
            message.data.Data = [{ Progress: message.errorMsg }];
            oldMsg.data.Result = 'FAIL';
            oldMsg.errorMsg = message.errorMsg;
          } else if (message.data.Result === 'OK') {
            message.data.Data = [{ Progress: message.errorMsg }];
          }
          oldMsg.data.Data = message.data.Data;
          oldMsg.datas = [message.data];
        } else {
          oldMsg.data.Data = message.data.Data;
        }
      }
      oldMsg.endTime = Date.now();
      // 下载表单
      if (message.cmd.toUpperCase().indexOf('UPLD ENODEBCFGDATA') >= 0 || message.cmd.toUpperCase().indexOf('UPLD ETCCFGDATA') >= 0
        || message.cmd.toUpperCase().indexOf('UPLD GNBCFGDATA') >= 0) {
        if (message.data.Result === 'OK') {
          // 去ftp指定路径下载文件
          this.download(message);
        }
      }
      if (['FAIL', 'OK'].indexOf(message.data.Result) > -1) {
        // 批量修改模式 如果两次操作失败 取消操作
        if (this.isMassModExecing
            && this.cancelledExec(message.data.Result)) { return; }
        // 如果是cmd执行，则删除执行行，整体上移
        if (this.cmdMode) {
          bus.$emit('deleteEditorLine');
        }
        // 继续执行下一次调用
        this.$emit('exec-next-mml');
      }
    },
    download(message) {
      const neid = message.data.neId;
      const filename = message.data.Parameters.ftpServerFileName;
      const params = new FormData();
      params.append('filename', filename);
      params.append('neid', neid);
      const config = {
        responseType: 'blob'
      };
      this.axios.post('/lte/ems/config/mml/enodeBCfgDataDownLoad', params, config).then(res => {
        console.log('enodeBCfgDataDownLoad', res);
        if(res.data.errorCode == undefined && res.data.size >200){  //增加一层判断 防止返回错误内容后也会下载文件
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        }       
      });
    },
    // V18A.0.11版本新增,当连续两次批量修改Mo失败时，取消本次操作
    cancelledExec(result) {
      this.recent2ExecuteResult.shift();
      this.recent2ExecuteResult.push(result);
      const recent2ResultStr = this.recent2ExecuteResult.join('');
      if (recent2ResultStr === 'FAILFAIL') {
        this.$emit('exec-stop');
        this.$layer.warn({
          msg: this.$t('MML.operationCancelled'),
        });
        return true;
      }
      return false;
    }
  },
  beforeDestroy(){
    mmlSocket.stopReceiveTopicMsg(this.getUserId(), '/user/#/MMLServer');
  }
};
</script>

<style>


</style>
